<template>
  <nav
    class="navbar navbar-expand-lg fixed-top header-auto euroc-navbar"
    :class="{ 'header-hidden': isHidden }"
  >
    <div class="container-fluid nav-shell">
      <section class="d-flex align-items-center gap-4">
        <!--<img src="../assets/euroc_v1_white_sm.png" alt="EuRoC" height="60" />-->
        <router-link class="brand-link my-text-color" to="/home" @click="onNav">
          <img class="brand-logo" src="../assets/euroc_nav.png" alt="EuRoC" />
        </router-link>

        <span v-if="isAuthenticated" class="edition-pill my-text-color">
          {{ _edition }}
        </span>
      </section>

      <!-- Hamburger: we toggle collapse programmatically -->
      <button
        id="navToggler"
        class="navbar-toggler nav-icon-button"
        type="button"
        :aria-expanded="isCollapsedOpen ? 'true' : 'false'"
        aria-controls="navbarNav"
        aria-label="Toggle navigation"
        @click="onTogglerClick"
      >
        <!-- show bars when closed -->
        <span class="my-text-color" v-show="!isCollapsedOpen">
          <i class="fa-solid fa-bars"></i>
        </span>
        <!-- show X when open -->
        <span class="my-text-color" v-show="isCollapsedOpen">
          <i class="fa-solid fa-xmark"></i>
        </span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
        <ul class="navbar-nav nav-actions gap-lg-2 align-items-lg-center">
          <!-- Admin only -->
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/users"
              @click="onNav"
              aria-label="Users"
              v-tooltip:bottom="'Users'"
            >
              <i class="fa-solid fa-user-gear"></i>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/categories"
              @click="onNav"
              aria-label="Categories"
              v-tooltip:bottom="'Categories'"
            >
              <i class="fa-solid fa-layer-group"></i>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/projects"
              @click="onNav"
              aria-label="Projects"
              v-tooltip:bottom="'Projects'"
            >
              <i class="fa-solid fa-diagram-project"></i>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/teams"
              @click="onNav"
              aria-label="Teams"
              v-tooltip:bottom="'Teams'"
            >
              <i class="fa-solid fa-people-group"></i>
            </router-link>
          </li>
          <li class="nav-item" v-if="isAuthenticated && levelID === 'ADM'">
            <router-link
              class="nav-link my-text-color"
              to="/teb"
              @click="onNav"
              aria-label="Manage TEB"
              v-tooltip:bottom="'Manage TEB'"
            >
              <i class="fa-solid fa-user-pen"></i>
            </router-link>
          </li>
          <!-- FRR (roles) -->
          <li
            class="nav-item"
            v-if="
              isAuthenticated &&
              ['TEB', 'TBL', 'OPL', 'ADM', 'OPS', 'PTS'].includes(levelID)
            "
          >
            <router-link
              class="nav-link my-text-color"
              to="/frr_projects"
              @click="onNav"
              v-tooltip:bottom="'FRR'"
            >
              <i class="fa-solid fa-clipboard-check me-1"></i>
              <span>FRR</span>
            </router-link>
          </li>
          <!-- Scoring direct access for TEB/TBL -->
          <li
            class="nav-item"
            v-if="isAuthenticated && ['TEB', 'TBL'].includes(levelID)"
          >
            <router-link
              class="nav-link my-text-color"
              to="/scoring_dashboard"
              @click="onNav"
            >
              <i class="fa-solid fa-clipboard-list me-1"></i>
              <span>Scoring</span>
            </router-link>
          </li>
          <!-- Scoring dropdown (Vue-controlled) -->
          <li
            class="nav-item dropdown"
            v-if="
              isAuthenticated && ['ADM', 'OPL', 'PTS', 'OPS'].includes(levelID)
            "
          >
            <a
              class="nav-link my-text-color d-flex align-items-center"
              href="#"
              :aria-expanded="openMenu === 'scoring' ? 'true' : 'false'"
              @click.prevent="toggle('scoring')"
            >
              <i class="fa-solid fa-clipboard-list me-1"></i>
              <span>Scoring</span>
              <i class="fa-solid fa-chevron-down ms-2 small"></i>
            </a>

            <ul
              class="dropdown-menu dropdown-menu-end"
              :class="{ show: openMenu === 'scoring' }"
            >
              <li v-if="isAuthenticated && levelID === 'ADM'">
                <router-link
                  class="dropdown-item"
                  to="/gradingparams"
                  @click="onNav"
                >
                  <i class="fa-solid fa-list-ol me-2"></i>
                  Grading (settings)
                </router-link>
              </li>
              <li v-if="isAuthenticated && levelID === 'ADM'">
                <hr class="dropdown-divider" />
              </li>

              <li
                v-if="
                  isAuthenticated && ['ADM', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/tr_projects"
                  @click="onNav"
                >
                  <i class="fa-regular fa-file-lines me-2"></i>
                  Technical Report
                </router-link>
              </li>
              <li
                v-if="
                  isAuthenticated && ['ADM', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/design_projects"
                  @click="onNav"
                >
                  <i class="fa-solid fa-gear me-2"></i>
                  Vehicle Design
                </router-link>
              </li>
              <li
                v-if="
                  isAuthenticated && ['ADM', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/effort_projects"
                  @click="onNav"
                >
                  <i class="fa-solid fa-people-carry-box me-2"></i>
                  Team Effort
                </router-link>
              </li>
              <li v-if="isAuthenticated && ['ADM', 'OPL'].includes(levelID)">
                <router-link
                  class="dropdown-item"
                  to="/flight_projects"
                  @click="onNav"
                >
                  <i class="fa-solid fa-rocket me-2"></i>
                  Flight Performance
                </router-link>
              </li>
              <li
                v-if="
                  isAuthenticated && ['ADM', 'OPL', 'PTS'].includes(levelID)
                "
              >
                <router-link
                  class="dropdown-item"
                  to="/pl_projects"
                  @click="onNav"
                >
                  <i class="fa-solid fa-microscope me-2"></i>
                  Payload
                </router-link>
              </li>
              <li v-if="isAuthenticated && levelID === 'ADM'">
                <router-link
                  class="dropdown-item"
                  to="/frr_parameters"
                  @click="onNav"
                >
                  <i class="fa-solid fa-list-check me-2"></i>
                  FRR (settings)
                </router-link>
              </li>
            </ul>
          </li>
          <!-- Reports -->
          <li class="nav-item" v-if="isAuthenticated">
            <router-link
              class="nav-link my-text-color"
              to="/reports"
              @click="onNav"
            >
              <i class="fa-solid fa-chart-line me-1"></i>
              <span>Reports</span>
            </router-link>
          </li>
          <!-- Launch Field dashboard -->
          <li
            class="nav-item"
            v-if="isAuthenticated && ['ADM', 'PTS'].includes(levelID)"
          >
            <router-link
              class="nav-link my-text-color"
              to="/launch_field"
              @click="onNav"
            >
              <i class="fa-solid fa-tower-broadcast me-1"></i>
              <span>Launch Field</span>
            </router-link>
          </li>

          <!-- Avatar -->
          <li class="nav-item dropdown" v-if="isAuthenticated">
            <a
              href="#"
              class="nav-link d-flex align-items-center account-trigger p-0"
              aria-label="Account menu"
              :aria-expanded="openMenu === 'settings' ? 'true' : 'false'"
              @click.prevent="toggle('settings')"
            >
              <img
                v-if="hasUserAvatar"
                :src="img"
                alt="User avatar"
                width="45"
                height="45"
                class="user-avatar"
              />
              <span v-else class="user-avatar user-avatar-initials">
                {{ userInitials }}
              </span>
              <i class="fa-solid fa-chevron-down ms-2 my-text-color small"></i>
            </a>

            <ul
              class="dropdown-menu dropdown-menu-end mt-2 account-menu"
              :class="{ show: openMenu === 'settings' }"
            >
              <li>
                <router-link
                  class="dropdown-item"
                  to="/useraccount"
                  @click="onNav"
                >
                  <i class="fa-regular fa-circle-user me-1"></i>
                  Profile
                </router-link>
              </li>

              <li><hr class="dropdown-divider" /></li>

              <li>
                <span class="dropdown-item-text role-current edition-current">
                  <i class="fa-solid fa-calendar-days me-2"></i>
                  <span>
                    <small>CURRENT EDITION</small>
                    <strong>EuRoC {{ _edition }}</strong>
                  </span>
                </span>
              </li>
              <li>
                <div class="edition-switch-grid">
                  <button
                    v-for="edition in editions"
                    :key="edition"
                    class="edition-switch-item"
                    :class="{ active: isActiveEdition(edition) }"
                    type="button"
                    :disabled="isActiveEdition(edition)"
                    @click.stop.prevent="switchEdition(edition)"
                  >
                    {{ edition }}
                  </button>
                </div>
              </li>

              <li><hr class="dropdown-divider" /></li>

              <li>
                <div class="dropdown-item-text theme-menu-item">
                  <span class="theme-menu-copy">
                    <i
                      :class="
                        isDarkTheme ? 'fa-solid fa-moon' : 'fa-solid fa-sun'
                      "
                    ></i>
                    <span>{{ isDarkTheme ? "Dark mode" : "Light mode" }}</span>
                  </span>
                  <button
                    class="theme-menu-toggle"
                    :class="{ 'is-dark': isDarkTheme }"
                    type="button"
                    role="switch"
                    :aria-checked="isDarkTheme ? 'true' : 'false'"
                    :aria-label="
                      isDarkTheme
                        ? 'Switch to light mode'
                        : 'Switch to dark mode'
                    "
                    @click.stop.prevent="toggleTheme"
                  >
                    <span class="theme-menu-toggle-thumb">
                      <i
                        :class="
                          isDarkTheme ? 'fa-solid fa-moon' : 'fa-solid fa-sun'
                        "
                      ></i>
                    </span>
                  </button>
                </div>
              </li>

              <template v-if="hasSwitchableLevels">
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <span class="dropdown-item-text role-current">
                    <i class="fa-solid fa-id-badge me-2"></i>
                    <small class="me-2">CURRENT LEVEL</small>
                  </span>
                  <strong class="ms-2">{{ activeLevelName }}</strong>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li v-for="level in switchableLevels" :key="level.levelID">
                  <button
                    class="dropdown-item role-switch-item"
                    type="button"
                    @click.stop.prevent="switchLevel(level)"
                  >
                    <i class="fa-solid fa-right-left"></i>
                    <span>&nbsp;{{ level.level }}</span>
                  </button>
                </li>
              </template>

              <li><hr class="dropdown-divider" /></li>

              <li>
                <router-link
                  class="dropdown-item"
                  to="/"
                  @click.stop.prevent="handleSignOut"
                >
                  <i class="fa-solid fa-arrow-right-from-bracket me-1"></i>
                  Sign out
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Not authenticated -->
          <li class="nav-item ms-auto" v-if="!isAuthenticated">
            <router-link
              class="nav-link my-text-color me-2"
              id="signin"
              to="/login"
              @click="onNav"
              aria-label="Sign in"
              v-tooltip:bottom="'Sign In'"
            >
              <i class="fa-solid fa-arrow-right-to-bracket"></i>
            </router-link>
          </li>
          <li class="nav-item ms-auto" v-if="!isAuthenticated">
            <router-link
              class="nav-link my-text-color me-2"
              id="register"
              to="/register"
              @click="onNav"
              aria-label="Register"
              v-tooltip:bottom="'Register'"
            >
              <i class="fa-solid fa-user-plus"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from "bootstrap";
import {
  notifyError,
  notifyInfo,
  notifySuccess,
} from "../modules/toastService";
import {
  DARK_THEME,
  LIGHT_THEME,
  applyTheme,
  getStoredTheme,
  saveTheme,
} from "../modules/theme";
import { mapActions, mapGetters } from "vuex";
import {
  IS_USER_AUTHENTICATED_GETTER,
  LOGOUT_ACTION,
  SWITCH_LEVEL_ACTION,
  GET_USER_LEVEL_GETTER,
  GET_USER_AVAILABLE_LEVELS_GETTER,
  GET_USER_NAME_GETTER,
  GET_USER_AVATAR_GETTER,
  GET_USER_ID_GETTER,
  GET_USER_TOKEN_GETTER,
  GET_EDITION_GETTER,
} from "../store/storeconstants";

export default {
  name: "Navbar",
  data() {
    return {
      openMenu: null, // 'scoring' | 'settings' | null
      isCollapsedOpen: false, // for aria-expanded on the button
      isHidden: false,
      lastY: 0,
      threshold: 50,
      selectedTheme: getStoredTheme(),
      editions: [2025, 2026, 2027, 2028, 2029, 2030],
    };
  },
  mounted() {
    this.selectedTheme = applyTheme(this.selectedTheme);
    this.lastY = window.pageYOffset || 0;
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },

  computed: {
    ...mapGetters("auth", {
      isAuthenticated: IS_USER_AUTHENTICATED_GETTER,
      levelID: GET_USER_LEVEL_GETTER,
      availableLevels: GET_USER_AVAILABLE_LEVELS_GETTER,
      name: GET_USER_NAME_GETTER,
      img: GET_USER_AVATAR_GETTER,
      token: GET_USER_TOKEN_GETTER,
      userID: GET_USER_ID_GETTER,
      _edition: GET_EDITION_GETTER,
    }),

    ...mapGetters("ui", { _unsaved: "HAS_UNSAVED_CHANGES" }),

    switchableLevels() {
      return (this.availableLevels || []).filter(
        (level) => level.levelID && level.levelID !== this.levelID,
      );
    },

    activeLevelName() {
      const activeLevel = (this.availableLevels || []).find(
        (level) => level.levelID === this.levelID,
      );
      return activeLevel?.level || this.levelID;
    },

    hasSwitchableLevels() {
      return this.switchableLevels.length > 0;
    },

    isDarkTheme() {
      return this.selectedTheme === DARK_THEME;
    },

    scrollEffectsDisabled() {
      return ["/home", "/main"].includes(
        String(this.$route.path || "").toLowerCase(),
      );
    },

    hasUserAvatar() {
      const img = String(this.img || "").trim();
      return Boolean(img) && !img.includes("/img/avatar.png");
    },

    userInitials() {
      const words = String(this.name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);

      if (words.length === 0) return "EU";
      if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    },
  },

  watch: {
    "$route.path"() {
      this.isHidden = false;
      this.lastY = window.pageYOffset || 0;
    },
  },

  methods: {
    ...mapActions("auth", {
      _logout: LOGOUT_ACTION,
      _switchLevel: SWITCH_LEVEL_ACTION,
    }),

    toggle(which) {
      this.openMenu = this.openMenu === which ? null : which;
      if (this.openMenu) {
        this.isHidden = false;
      }
    },
    toggleTheme() {
      const nextTheme = this.isDarkTheme ? LIGHT_THEME : DARK_THEME;
      this.selectedTheme = saveTheme(nextTheme);
    },
    isActiveEdition(edition) {
      return String(edition) === String(this._edition);
    },
    onScroll() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (this.scrollEffectsDisabled) {
        this.isHidden = false;
        this.lastY = y;
        return;
      }

      if (this.openMenu || this.isCollapsedOpen) {
        this.isHidden = false;
        this.lastY = y;
        return;
      }

      if (y < 80) {
        this.isHidden = false;
        this.lastY = y;
        return;
      }

      if (y - this.lastY > 10) {
        this.isHidden = true;
      } else if (this.lastY - y > 10) {
        this.isHidden = false;
      }

      this.lastY = y;
    },
    async logout() {
      const ok = await this._logout();
      if (ok) {
        notifyInfo("Signed out.");
        await this.$router.replace("/home");
      }
      return ok;
    },

    async handleSignOut() {
      this.onNav();
      if (this._unsaved) {
        return; // BLOCK sign out
      }
      const ok = await this.logout();
      if (ok) {
        this.openMenu = null;
      }
    },

    async switchLevel(level) {
      if (this._unsaved) {
        notifyError("Save or discard changes before switching level.");
        return;
      }
      if (!level?.levelID || level.levelID === this.levelID) return;

      try {
        const response = await this._switchLevel({
          levelID: level.levelID,
          editionyear: this._edition,
        });

        if (response.data.code === "levelswitched") {
          notifySuccess(`Switched to ${level.level}.`);
          this.openMenu = null;
          this.onNav();
          if (this.$route.path !== "/home") {
            await this.$router.replace("/home");
          }
          return;
        }

        if (response.data.code === "tebassignmentmissing") {
          notifyError("No TEB/TBL assignment found for this edition.");
          return;
        }

        notifyError("Could not switch level.");
      } catch (error) {
        notifyError(error?.response?.data?.detail || "Could not switch level.");
      }
    },

    async switchEdition(edition) {
      if (this._unsaved) {
        notifyError("Save or discard changes before switching edition.");
        return;
      }
      if (!edition || this.isActiveEdition(edition) || !this.levelID) return;

      try {
        const response = await this._switchLevel({
          levelID: this.levelID,
          editionyear: edition,
        });

        if (response.data.code === "levelswitched") {
          notifySuccess(`Switched to EuRoC ${edition}.`);
          this.openMenu = null;
          this.onNav();
          if (this.$route.path !== "/home") {
            await this.$router.replace("/home");
          }
          return;
        }

        if (response.data.code === "tebassignmentmissing") {
          notifyError(`No TEB/TBL assignment found for EuRoC ${edition}.`);
          return;
        }

        notifyError("Could not switch edition.");
      } catch (error) {
        notifyError(
          error?.response?.data?.detail || "Could not switch edition.",
        );
      }
    },

    onNav() {
      // Close the mobile menu after navigation & any open dropdown
      const el = document.getElementById("navbarNav");
      if (el) {
        const inst = Collapse.getOrCreateInstance(el, { toggle: false });
        inst.hide();
      }
      this.isCollapsedOpen = false;
      this.openMenu = null;
    },

    onTogglerClick() {
      // Always close dropdowns first so nothing overlays the button
      this.openMenu = null;

      // Toggle the collapse explicitly (do not rely on data API)
      const el = document.getElementById("navbarNav");
      if (!el) return;

      const inst = Collapse.getOrCreateInstance(el, { toggle: false });
      if (el.classList.contains("show")) {
        inst.hide();
        this.isCollapsedOpen = false;
      } else {
        this.isHidden = false;
        inst.show();
        this.isCollapsedOpen = true;
      }
    },
  },
};
</script>

<style>
.euroc-navbar {
  background: #3152f5;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 14px 30px rgba(10, 31, 84, 0.22);
}

.nav-shell {
  min-height: 82px;
  padding: 0.55rem clamp(0.85rem, 2vw, 1.6rem);
}

.brand-link {
  display: inline-flex;
  align-items: center;
  padding: 0 !important;
  text-decoration: none;
}

.brand-logo {
  width: auto;
  height: 60px;
  object-fit: contain;
  filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.16));
}

.edition-pill {
  max-width: 14rem;
  padding: 0.28rem 0.55rem;
  overflow: hidden;
  font-size: 0.9rem;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
}

.nav-actions {
  gap: 0.35rem;
}

.euroc-navbar .nav-link {
  border-radius: 8px;
  font-weight: 700;
  transition: background-color 0.18s ease, color 0.18s ease,
    transform 0.18s ease;
}

.euroc-navbar .navbar-nav > .nav-item > .nav-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  min-height: 42px;
  padding: 0.55rem 0.7rem;
}

.euroc-navbar .navbar-nav > .nav-item > .nav-link > i:first-child {
  color: #dffbff;
}

.user-name-chip {
  max-width: 12rem;
  overflow: hidden;
  color: #ffffff !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

.user-avatar {
  display: inline-flex;
  width: 45px;
  height: 45px;
  align-items: center;
  justify-content: center;
  flex: 0 0 45px;
  object-fit: cover;
  background-color: white;
  border: 2px solid rgba(255, 255, 255, 0.82);
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(10, 31, 84, 0.18);
  cursor: pointer;
}

.user-avatar-initials {
  color: #3152f5;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  background: #e4ff26;
  border: 1px solid #e4ff26;
  text-transform: uppercase;
}

.nav-icon-button {
  width: 44px;
  height: 44px;
  padding: 0;
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.32);
  border-radius: 8px;
}

.account-trigger {
  height: 100%;
}

.account-trigger img.user-avatar {
  display: block;
}
.account-menu {
  width: min(340px, calc(100vw - 1rem));
  max-width: min(340px, calc(100vw - 1rem));
}

.theme-menu-item {
  padding: 0.65rem 0.75rem;
  display: flex !important;
  gap: 0.75rem;
  align-items: center;
  justify-content: space-between;
  color: #1e293b;
  line-height: 1;
  white-space: nowrap;
}

.theme-menu-copy {
  min-width: max-content;
  display: inline-flex !important;
  gap: 0.55rem;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.theme-menu-copy i {
  width: 20px;
  color: #3152f5;
  text-align: center;
}

.theme-menu-toggle {
  position: relative;
  flex: 0 0 auto;
  width: 58px;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  background: #f8fafc;
  box-shadow: inset 0 1px 3px rgba(15, 23, 42, 0.12);
  cursor: pointer;
  line-height: 1;
  transition: background 0.18s ease, border-color 0.18s ease;
}

.theme-menu-toggle-thumb {
  position: absolute;
  top: 50%;
  left: 3px;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  color: #3152f5;
  font-size: 0.76rem;
  background: #e4ff26;
  box-shadow: 0 7px 14px rgba(15, 23, 42, 0.2);
  transform: translateY(-50%);
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.theme-menu-toggle.is-dark {
  border-color: rgba(228, 255, 38, 0.36);
  background: #3152f5;
}

.theme-menu-toggle.is-dark .theme-menu-toggle-thumb {
  color: #e4ff26;
  background: #0f172a;
  transform: translate(26px, -50%);
}

.theme-menu-toggle:focus-visible {
  outline: 3px solid rgba(49, 82, 245, 0.26);
  outline-offset: 3px;
}

.role-current {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  padding: 0.55rem 0.75rem;
  color: #334155;
  line-height: 1.2;
  white-space: normal;
}

.role-current i {
  color: #3152f5;
}

.role-current span {
  display: grid;
  gap: 0.1rem;
}

.role-current small {
  font-size: 0.72rem;
  font-weight: 800;
  color: #64748b;
  text-transform: uppercase;
}

.role-current strong {
  font-size: 0.88rem;
  color: #1e293b;
  overflow-wrap: anywhere;
}

.edition-current {
  padding-bottom: 0.35rem;
}

.edition-switch-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.35rem;
  padding: 0 0.75rem 0.55rem;
}

.edition-switch-item {
  border: 1px solid #dbe6f2;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0.35rem 0.45rem;
  color: #3152f5;
  font-size: 0.84rem;
  font-weight: 850;
  line-height: 1;
  background: #f8fafc;
  transition: border-color 0.18s ease, background 0.18s ease, color 0.18s ease,
    transform 0.18s ease;
}

.edition-switch-item:hover:not(:disabled),
.edition-switch-item:focus-visible:not(:disabled) {
  border-color: rgba(49, 82, 245, 0.36);
  color: #1d4ed8;
  background: #eaf6ff;
  transform: translateY(-1px);
}

.edition-switch-item.active,
.edition-switch-item:disabled {
  border-color: #3152f5;
  color: #ffffff;
  background: #3152f5;
  cursor: default;
  opacity: 1;
}

.role-switch-item {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  gap: 0.55rem;
  align-items: flex-start;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  line-height: 1.25;
  white-space: normal !important;
}

.role-switch-item i {
  flex: 0 0 auto;
  margin-top: 0.15rem;
  color: #3152f5;
}

.role-switch-item span {
  min-width: 0;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
}

.nav-menu-trigger {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.dropdown-item i {
  width: 20px;
  text-align: center;
  opacity: 0.8;
}

.dropdown-item:hover i {
  opacity: 1;
}

.account-trigger .user-avatar {
  cursor: pointer;
}

.account-trigger:hover .user-avatar {
  opacity: 0.85;
}
.header-auto {
  z-index: 1051;
  transform: translateY(0);
  transition: transform 0.25s ease;
  will-change: transform;
}

.header-hidden {
  transform: translateY(-100%);
}

.euroc-navbar a:focus-visible,
.euroc-navbar button:focus-visible {
  outline: 3px solid rgba(223, 251, 255, 0.9);
  outline-offset: 3px;
}
.my-text-color {
  color: white !important;
}

.navbar .navbar-nav .nav-link:hover {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.14);
  transform: translateY(-1px);
}
.navbar .navbar-nav .nav-item {
  position: relative;
}

.navbar .dropdown-menu {
  overflow-wrap: anywhere;
}
.navbar .dropdown-menu-end {
  right: 0;
  left: auto;
}
.navbar .dropdown-menu {
  max-width: min(320px, calc(100vw - 1rem));
  padding: 0.45rem;
  border: 0;
  border-radius: 8px;
  box-shadow: 0 18px 42px rgba(0, 30, 60, 0.22);
}

.navbar .dropdown-item {
  border-radius: 8px;
  font-weight: 650;
}

.navbar .dropdown-item:hover,
.navbar .dropdown-item:focus {
  background: #eaf6ff;
  color: #003d72;
}

/* Vue-controlled dropdown visibility */
.dropdown-menu.show {
  display: block !important;
}

/* Hide caret on the ellipsis dropdown only */
.navbar .dropdown-toggle.no-caret::after {
  display: none !important;
}

/* ✅ Make sure the toggler (bars/X) always gets the click */
.navbar .navbar-toggler {
  position: relative;
  z-index: 9999;
  pointer-events: auto;
}

/* ✅ Responsive dropdown positioning:
   - On mobile (< lg) keep dropdowns static so they don't overlay the header/toggler
   - On desktop (≥ lg) make them absolute popovers */
@media (max-width: 991.98px) {
  .euroc-navbar {
    max-height: 100dvh;
    overflow: visible;
  }

  .nav-shell {
    min-height: 74px;
    align-items: flex-start;
    padding-bottom: 0.45rem;
  }

  .brand-logo {
    height: 52px;
  }

  .navbar-collapse {
    width: 100%;
    max-height: calc(100dvh - 74px);
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    padding-bottom: calc(1.25rem + env(safe-area-inset-bottom));
  }

  .nav-actions {
    gap: 0.25rem;
    padding: 0.55rem;
    margin-top: 0.7rem;
    background: rgba(0, 27, 72, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 8px;
  }

  .euroc-navbar .navbar-nav > .nav-item > .nav-link {
    justify-content: flex-start;
    width: 100%;
  }

  .navbar .dropdown-menu {
    position: static !important;
    margin: 0.25rem 0 0.35rem;
    box-shadow: none;
  }

  .navbar .account-menu.dropdown-menu.show {
    position: fixed !important;
    top: calc(74px + env(safe-area-inset-top));
    right: max(0.75rem, env(safe-area-inset-right));
    left: max(0.75rem, env(safe-area-inset-left));
    z-index: 1065;
    width: auto;
    max-width: none;
    max-height: calc(
      100dvh - 90px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
    );
    margin: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));
    box-shadow: 0 22px 50px rgba(0, 30, 60, 0.28);
  }

  .navbar .account-menu .dropdown-item,
  .navbar .account-menu .dropdown-item-text {
    min-height: 40px;
  }

  .navbar .account-menu .dropdown-divider {
    margin: 0.35rem 0;
  }

  .navbar .account-menu .edition-switch-grid {
    padding-bottom: 0.35rem;
  }
}
@media (min-width: 992px) {
  .navbar .dropdown-menu {
    position: absolute;
    z-index: 1062;
  }
}
</style>
